export const ACTIVE_THEME = 'ACTIVE_THEME';
export const UPDATE_COMPANY = 'UPDATE_COMPANY';
export const UPDATE_LOGO = 'UPDATE_LOGO';